var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.formId,attrs:{"data-external":"klaviyo-form-embed"}})
}
var staticRenderFns = []

export { render, staticRenderFns }